/*
const isIos = () => {
  return [
    'iPad Simulator',
    'iPhone Simulator',
    'iPod Simulator',
    'iPad',
    'iPhone',
    'iPod'
  ].includes(navigator.platform)
  // iPad on iOS 13 detection
  || (navigator.userAgent.includes('Mac') && 'ontouchend' in document);
};
 */

const vhFix = () => {
  const countSizes = () => {
    let vh = document.documentElement.clientHeight * 0.01;
    document.documentElement.style.setProperty('--scrollvh', `${vh}px`);
  };

  countSizes();
  window.addEventListener('resize', countSizes);
};

export {vhFix};
